import React from 'react'

import { Banner } from '@/components/banners/Banner'
import { Button } from '@/components/buttons/Button'

/**
 * Banner component to show staged changes warning
 */
export const StagedChangesBanner = ({ onClear, onSaveToScorecard, savingToScorecard }) => {
  return (
    <Banner caution className="staged-changes-banner">
      <div className="flex-align-center flex-space-between full-width">
        <span>
          <strong>You have staged changes.</strong> Test your edits, then resolve to apply them.
        </span>
        <div className="flex-align-center small-gap">
          <Button xs onClick={onClear} disabled={savingToScorecard}>
            Clear Changes
          </Button>
          {onSaveToScorecard && (
            <Button
              xs
              onClick={onSaveToScorecard}
              loading={savingToScorecard}
              disabled={savingToScorecard}
              data-testid="save-prompt-to-scorecard-button"
            >
              Save to Scorecard
            </Button>
          )}
        </div>
      </div>
    </Banner>
  )
}
